import React, { useState } from 'react';
import { Box, FormControl, Select, OutlinedInput, MenuItem, TextField, FormControlLabel, Radio, InputAdornment, Button, Typography } from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { useThemeContext } from '../context/ThemeContext';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const subCategory = [
  'Plumbing',
  'Electrical Work',
  'Carpentry',
  'Cleaning Services',
  'Painting',
  'Gardening and Landscaping',
  'Appliance Repair',
  'Construction and Masonry',
  'Vehicle Repair and Maintenance',
  'Tutoring',
  'Lawyers',
  'Property Valuers'
];

const names = [
  'Leak Fixing',
'Pipe Installation',
'Water Heater Repair',
'Faucet Replacement',
'Borehole Installation',
'Other Services'
]


const JobPostForm = () => {
  const { isSM, isMd, isMD } = useThemeContext()

  const [personName, setPersonName] = useState([]);
  const [selectedTime, setSelectedTime] = useState([]);
  const [selectedValue, setSelectedValue] = useState('a');



  const timeChange = (event) => {
    setSelectedTime(event.target.value);
  };
  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      typeof value === 'string' ? value.split(',') : value,
    );
  };

   
 
     const RadioChange = (event) => {
         setSelectedValue(event.target.value);
     };
 
     const controlProps = (item) => ({
         checked: selectedValue === item,
         onChange: RadioChange,
         value: item,
         name: 'color-radio-button-demo',
         inputProps: { 'aria-label': item },
     });
 


  const Times = ["09:00", "10:00", "11:00", "12:00", "13:00", "14:00"];

  return (
    <Box sx={{ width: isSM ? '100%' : isMD ? '100%' : isMd ? '1030px' : '1030px', maxHeight: '100%', margin: 'auto', padding: isSM ? '1rem' : isMD ? '1rem' : isMd ? '10px' : 0 }}>

      

      <Box display="flex" flexDirection={{ xs: 'row', md: 'row' }} gap={3} mb={3}>
        <FormControl sx={{  width: "100%", mt: 3, outline: "none" }}>
        <Typography variant="h5" sx={{mb:2}} >Service Categories</Typography>
          <Select
            multiple
            displayEmpty
            value={personName}
            onChange={handleChange}

            sx={{

              "& .MuiSelect-icon": {
                color: "#28A745",
              },
            }}


            input={<OutlinedInput />}
            renderValue={(selected) => {
              if (selected.length === 0) {
                return <span>Slected</span>;
              }

              return selected.join(', ');
            }}
            MenuProps={MenuProps}
            inputProps={{ 'aria-label': 'Without label' }}
          >

            {names.map((name) => (
              <MenuItem
                key={name}
                value={name}

              >
                {name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl sx={{ width: "100%", mt: 3, outline: "none" }}>
        <Typography variant="h5" sx={{mb:2}}>Service Categories</Typography>
          <Select
            multiple
            displayEmpty
            value={personName}
            onChange={handleChange}
            input={<OutlinedInput />}
            renderValue={(selected) => selected.length === 0 ? <span>Select a Sub Category</span> : selected.join(', ')}
            sx={{ '& .MuiSelect-icon': { color: '#28A745' } }}
          >
            {subCategory.map((name) => (
              <MenuItem key={name} value={name}>
                {name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <Typography variant="h5" mb={1}>
        Description <span style={{ color: '#666666' }}>(optional)</span>
      </Typography>
      <TextField multiline rows={5} fullWidth variant="outlined" />

      <Box sx={{ my: 5 }}>
        <iframe
          title="Google Map"
          height="375"
          width="100%"
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12609.73108660754!2d-122.47279800000001!3d37.803331!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808586e6302615a1%3A0x86bd130251757c00!2sStorey%20Ave%2C%20San%20Francisco%2C%20CA%2094129!5e0!3m2!1sen!2sus!4v1591859311334!5m2!1sen!2sus"
        />
      </Box>

      <Typography variant="h5" mt={3}>Location</Typography>
      <TextField variant="outlined" fullWidth sx={{ height: '40px', my: 2 }} />

      <Typography variant="h5" mt={3}>Material</Typography>
      <TextField variant="outlined" fullWidth sx={{ height: '40px', my: 2 }} />

      <Typography variant="h5" mt={3}>Select Date and Time</Typography>
      <Box display="flex" flexDirection={{ xs: 'row', md: 'row' }} gap={3} mt={2}>
       
           <FormControlLabel control={<Radio {...controlProps("a")} color="success" />} label="Success Option"/>
        <FormControlLabel control={<Radio {...controlProps("b")} color="success" />} label="Success Option"/>
        </Box>

      <Box display="flex" flexDirection={{ xs: 'row', md: 'row' }} gap={3} mt={2}>
        <TextField
          type="text"
          placeholder="MM/DD/YYYY"
          variant="outlined"
          fullWidth
          sx={{ maxWidth: 450 }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <CalendarTodayIcon sx={{ color: "#28A745" }} />
              </InputAdornment>
            ),
          }}
        />

        <FormControl fullWidth sx={{ maxWidth: 450 }}>
          <Select
            multiple
            displayEmpty
            value={selectedTime}
            onChange={timeChange}
            input={<OutlinedInput />}
            IconComponent={AccessTimeIcon}
            renderValue={(selected) => selected.length === 0 ? <span>Select preferred time</span> : selected.join(', ')}
            sx={{ '& .MuiSelect-icon': { color: '#28A745' } }}
          >
            {Times.map((time) => (
              <MenuItem key={time} value={time}>
                {time}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>

      <Box mt={4} textAlign="center">
        <Button
          variant="contained"
          sx={{

            height: '50px',
            width: isSM ? '200px' : isMD ? '250px' : isMd ? '450px' : '450px',
            margin: '50px 0 50px 5px',
            borderRadius: '12px',
            border: 'none',
            color: '#fff',
            backgroundColor: '#28A745',
            fontSize: isSM ? '16px' : isMD ? '18px' : isMd ? '20px' : '24px',
            fontWeight: '500',
            lineHeight: '20px',
            textAlign: 'justify',
            textUnderlinePosition: 'from-font',
            textDecorationSkipInk: 'none',
            '&:hover': {
              backgroundColor: '#218838',
            }
          }}
        >
          Post Job
        </Button>


      </Box>
    </Box>
  );
};

export default JobPostForm;
